import React, { useContext } from "react";
import { Button, Icon, Select } from "antd";
import style from "./index.module.scss";
import { sectionDescribe, weekHanzi } from "service/service";
import { useHistory } from "react-router-dom";
import { courseDetailUrlNoWeekId } from "service/url";
import { CourseContext, CoursePlanAtom } from "../../../../Store";
import { useAtomValue } from "jotai";
import lodash from "lodash-es";

export default function SectionPicker() {
    const { course, path } = useContext(CourseContext);
    const history = useHistory();

    const list = useAtomValue(
        CoursePlanAtom({
            courseNo: course.courseNo,
            courseSeq: course.courseSeq
        })
    );

    function handlerSelectChange(weekTimeId: number) {
        const _course = lodash.cloneDeep(course);
        _course.weekTimeId = weekTimeId;
        history.replace(courseDetailUrlNoWeekId(_course, `/${path}`));
    }

    const index = list.findIndex(
        item => Number(item.weekTimeId) === course.weekTimeId
    );

    function handleCheck(index: number) {
        const newWeekTimeId = Number(list[index].weekTimeId);
        handlerSelectChange(newWeekTimeId);
    }

    if (!list) return null;

    return (
        <div>
            <Button
                type="link"
                className={style.arrBtn}
                onClick={() => handleCheck(index - 1)}
                disabled={index === 0}>
                <Icon type="left" className={style.icon} />
            </Button>

            <Select
                className={style.root}
                value={course.weekTimeId}
                onChange={handlerSelectChange}
                showArrow={false}>
                {list.map(item => (
                    <Select.Option
                        value={item.weekTimeId}
                        key={item.weekTimeId}>
                        第{item.weekTime}周 {weekHanzi(item.week)}{" "}
                        {sectionDescribe(item.section, item.continunity)}
                    </Select.Option>
                ))}
            </Select>

            <Button
                type="link"
                className={style.arrBtn}
                onClick={() => handleCheck(index + 1)}
                disabled={index === list.length - 1}>
                <Icon type="right" className={style.icon} />
            </Button>
        </div>
    );
}
